import React from "react";
import { Link } from "react-router-dom";
import p1 from '../temp/p1.avif'
import p2 from '../temp/p2.avif'
import p3 from '../temp/p3.jpg'

import "./search.css";
const Search = () => {
  return (
    <div className="search">
      <div className="container">
        <div className="row">
          <div className="col-left p-sm">
            <div className="filter-container">
              <form className="filter-form">
                <div className="filter-item">
                  <input type="text" className="filter-input" placeholder="Enter Keyword" />
                </div>
                <div className="filter-item">
                  <span className="filter-item-label">Your Budget</span>
                    <div className="filter-item-i">
                      <label htmlFor="p-from">From</label>

                      <select name="p-from" id="p-from">
                        <option value="100000">Ksh 100000</option>
                        <option value="100000">Ksh 200000</option>
                        <option value="100000">Ksh 300000</option>
                        <option value="100000">Ksh 400000</option>
                        <option value="100000">Ksh 500000</option>
                      </select>
                    </div>
                    <div className="filter-item-i">
                      <label htmlFor="p-to">To</label>
                      <select name="p-to" id="p-to">
                        <option value="100000">ksh 100000</option>
                        <option value="100000">ksh 200000</option>
                        <option value="100000">ksh 300000</option>
                        <option value="100000">ksh 400000</option>
                        <option value="100000">ksh 500000</option>
                      </select>
                    </div>
                </div>
                <div className="filter-item">
                  <span className="filter-item-label">Property Type</span>
                  <select name="property-type" id="property-type">
                    <option value="">Property Type</option>
                    <option value="Beditter">Bedsitter</option>
                    <option value="Beditter">Apartment</option>
                    <option value="Beditter">Hostel</option>
                    <option value="Beditter">Office Space</option>
                  </select>
                  </div>
                  <div className="filter-item">
                    <div className="filter-item-label">Property Purpose</div>
                    <select name="property-purpose" id="">
                        <option value="">Property purpose</option>
                        <option value="rental">Rental</option>
                        <option value="sale">Sale</option>

                    </select>
                  </div>
              
              <button className="filter-properties-btn">Apply Filter</button>
              </form>
            </div>
          </div>

          <div className="col-right p-sm">
            <div className="header">
            
                <div className="header-item">
                  <label htmlFor="resPerPage" className="header-item-label">Showing 20 results per page</label>
                  <select name="resPerPage" id="resPerPage">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                  </select>
              </div>
            </div>
            <div className="row p-lg">
              <div className="col">
                <div className="property">
                <span className="property-type f-sale">
                      
                      For Sale
                    </span>
                  <div className="property-img">
                    <Link to="/">
                    <img src={p3} alt="" /> 
                      </Link>
                  </div>
                  <div className="property-details">
                  <span className="property-price">Ksh 10000</span>

                    <h2 className="property-title">Sephkims</h2>
                    <Link to="" className="more-details-btn">More Details</Link>

                  </div>
                </div>
              
              </div>
              <div className="col">
                <div className="property">
                <span className="property-type f-sale">
                      
                      For Sale
                    </span>
                  <div className="property-img">
                   
                    <Link to="/">
                    <img src={p2} alt="" />
                      </Link>
                  </div>
                  <div className="property-details">
                  <span className="property-price">Ksh 10000</span>
                    <h2 className="property-title">Peaceful Homes</h2>
                    <Link to="" className="more-details-btn">More Details</Link>
                  </div>
                </div>
              
              </div>
              <div className="col">
                <div className="property">
                  <div className="property-img">
                  <span className="property-type f-re">
                    <div className="bg"></div>
                      For Rental
                    </span>
                    <img src={p1} alt="" />
                  </div>
                  <div className="property-details">
                  <span className="property-price">Ksh 10000</span>     
                    <h2 className="property-title">Pink House</h2>
                    <a href="" className="more-details-btn">More Details</a>
                  </div>
                </div>
              
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
